import { z } from 'zod';

export type ErrorDetails = z.infer<typeof ErrorDetails>;

export const ErrorDetails = z.object({
  type: z.string().nullish(),
  title: z.string().nullish(),
  status: z.number().nullish(),
  detail: z.string().nullish(),
});
